import clsx from "clsx";

export const TEXT_SIZES_VARIABLES = {
  xs: "xs", //h5
  default: "default", //h4
  medium: "medium", //h3
  large: "large", //h2
  xl: "xl", //h1
  // xxl: "xxl",
  xxxl: "xxxl",
  // xxxxl: "xxxxl",
} as const;

export const TEXT_SIZES = {
  [TEXT_SIZES_VARIABLES.xs]: clsx("text-[14px] md:text-[14px] leading-[130%]"),
  [TEXT_SIZES_VARIABLES.default]: clsx(
    "text-[16px] md:text-[16px] leading-[120%]",
  ),
  [TEXT_SIZES_VARIABLES.medium]: clsx(
    "text-[18px] md:text-[18px] leading-[120%]",
  ),
  [TEXT_SIZES_VARIABLES.large]: clsx(
    "text-[24px] md:text-[24px] leading-[120%]",
  ),
  [TEXT_SIZES_VARIABLES.xl]: clsx("text-[32px] md:text-[32px] leading-[120%]"),
  // [TEXT_SIZES_VARIABLES.xxl]: clsx("text-[32px] md:text-[32px] leading-[120%]"),
  [TEXT_SIZES_VARIABLES.xxxl]: clsx(
    "text-[54px] md:text-[54px] leading-[100%]",
  ),
  // [TEXT_SIZES_VARIABLES.xxxxl]: clsx("text-[30px] md:text-[48px] leading-[100%]"),
};
